
import $ from 'jquery';

const Notifications = {};

$.extend(Notifications, {
    messages: (messages) => {
        if (!messages) {
            return;
        }

        $.each(messages, (type, messages) => {
            Notifications[type].apply(null, [messages])
        });
    },

    info: (messages) => {
        if (!Array.isArray(messages)) {
            messages = [messages];
        }
        messages.forEach((message) => {
            alertify.message(message)
        })
    },

    success: (messages) => {
        if (!Array.isArray(messages)) {
            messages = [messages];
        }
        messages.forEach((message) => {
            alertify.success(message)
        })
    },

    error: (messages) => {
        if (!Array.isArray(messages)) {
            messages = [messages];
        }
        messages.forEach((message) => {
            alertify.error(message)
        })
    },

    warning: (messages) => {
        if (!Array.isArray(messages)) {
            messages = [messages];
        }
        messages.forEach((message) => {
            alertify.warning(message)
        })
    }
});


// Export vers window
window.Notifications = Notifications;


// WEBPACK FOOTER //
// ./js/form/notification.js